import { useDataSyncTranslations } from 'modules/dataSync/hooks/useDataSyncTranslations';
import { EmptyStateWrapper, TableWrapper } from './DestinationTable.styles';
import { getDestinationTableHeaders } from 'modules/dataSync/utils';
import { HeaderRow } from './HeaderRow';
import { useDestinationTable } from 'modules/dataSync/contexts';
import { BodyRow } from './BodyRow';
import { SkeletonRow } from './SkeletonRow';
import { EmptyState } from 'ui/emptyState';
import { NoResult, EmptyState as EmptyStateIllustration } from 'ui/illustrations';

const LOADING_ROW_COUNT = 5; // Number of skeleton rows to display while loading

export const DestinationTable = () => {
  const { t } = useDataSyncTranslations();
  const {
    loading,
    sortBy,
    sortDirection,
    displayedDestinations,
    searchQuery,
    setSortBy,
    setSortDirection,
  } = useDestinationTable();
  const columns = getDestinationTableHeaders(t);
  const skeletonColumnCount = Object.keys(columns).length;

  const tableContent = () => {
    switch (true) {
      case displayedDestinations.length > 0:
        return displayedDestinations.map((destination) => (
          <BodyRow key={destination.id} destination={destination} />
        ));

      case loading:
        return [...Array(LOADING_ROW_COUNT)].map((_, i) => (
          <SkeletonRow key={i} skeletonColumnCount={skeletonColumnCount} />
        ));

      case displayedDestinations.length === 0 && searchQuery.length > 0:
        return (
          <EmptyStateWrapper>
            <EmptyState
              title={t('states.empty.title')}
              subtitle={t('states.empty.subtitle')}
              Illustration={NoResult}
            />
          </EmptyStateWrapper>
        );

      default:
        return (
          <EmptyStateWrapper>
            <EmptyState
              title={t('empty.noDestinations')}
              subtitle={t('empty.createDestination')}
              Illustration={EmptyStateIllustration}
            />
          </EmptyStateWrapper>
        );
    }
  };

  return (
    <TableWrapper>
      <HeaderRow
        sortedBy={sortBy}
        setSortedBy={setSortBy}
        sortDirection={sortDirection}
        setSortDirection={setSortDirection}
        columns={columns}
      />
      {tableContent()}
    </TableWrapper>
  );
};
